const doc = [({"en":({"js":({"admin":({"sheet_sizes":({"create_card":({"create_sheet_size":"Create sheet size"})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;